import { FC, PropsWithChildren } from "react";

import classNames from "classnames";

import { Stack } from "../../layout";
import { Body, Semibold } from "../../typography";
import { useTableStyles } from "./TableStylesContext";

/** The `NoResultsOnFilter` component properties. */
export interface NoResultsOnFilterProps {}

/**
 * The `NoResultsOnFilter` component.
 */
export const NoResultsOnFilter: FC<PropsWithChildren<NoResultsOnFilterProps>> = () => {
  const { styles } = useTableStyles();

  return (
    <Stack spacing="mini" className={classNames(styles.NoResultsOnFilter, "no-results")}>
      <Body textAlign="center" size="medium">
        <Semibold>No Results Found</Semibold>
      </Body>
    </Stack>
  );
};
